<template>
  <v-card v-if="value">
    <v-card-title :class="themes.candidate.light.dialogTitle">
      <span class="title">{{ value.id ? 'Edit Subject' : 'New Subject' }}</span>
      <v-spacer />
      <!-- Indicate referenced status -->
      <v-tooltip v-if="component.qualificationComponentId" left :color="themes.candidate.light.tooltip">
        <v-icon slot="activator" :color="themes.candidate.light.success">
          mdi-bookmark-check
        </v-icon>
        <span>This item is referenced from our database</span>
      </v-tooltip>
      <v-tooltip v-else left :color="themes.candidate.light.tooltip">
        <v-icon slot="activator" :color="themes.candidate.light.warning">
          mdi-bookmark-off
        </v-icon>
        <span>This item is not referenced from our database</span>
      </v-tooltip>
    </v-card-title>
    <v-divider />
    <v-form v-model="valid" @submit.prevent="save">
      <v-card-text>
        <v-combobox
          label="Name"
          v-model="component.description"
          :items="items" item-value="description" item-text="description"
          :search-input.sync="search" :loading="searching" no-filter
          :rules="rules.description"
          placeholder="e.g. Mathematics A"
          required @input="setComponent"
          :color="themes.candidate.light.input"
        />

        <v-text-field v-if="component.description && component.description.length"
          label="Reference"
          v-model="component.reference"
          :readonly="!!component.qualificationComponentId"
          hint="Optional: leave blank if you don't know the course code or reference"
          :rules="rules.reference"
          :color="themes.candidate.light.input"
        />

        <!-- Component Grade -->
        <GradeSelect
          v-if="component.description &&
          component.description.length &&
          profileQualification.startsAt &&
          new Date(profileQualification.startsAt) < new Date()"
          :value="component"
          @input="setGrade"
        />

      </v-card-text>
      <v-divider />
      <v-card-actions><v-spacer />
        <v-btn flat @click="$emit('close')"
          :color="themes.candidate.light.cancel">
          Cancel
        </v-btn>
        <v-btn type="submit"
          :color="themes.candidate.light.primaryActionButton"
          :disabled="!valid"
          :loading="saving">
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
// Helpers
import _ from 'lodash'

// components
import GradeSelect from '@/components/selects/GradeSelect'

export default {
  components: { GradeSelect },
  props: { value: Object, profileQualification: Object },
  data() {
    return {
      // Model
      component: JSON.parse(JSON.stringify(this.value)),
      // Validation
      valid: !!this.value.id,
      rules: {
        description: [v => !!v || 'must be provided'],
        reference: [],
      },
      // Submission
      saving: false,
      // Search
      search: '',
      searching: false,
      items: [],
    }
  },

  watch: {
    search: _.debounce(function(term) {
      if (term !== this.component.description) {
        let params = { search: term }
        if (this.profileQualification.qualificationType) {
          Object.assign(params, { qualification_type: this.profileQualification.qualificationType.id })
        }
        if (this.profileQualification.institution) {
          Object.assign(params, { institution: this.profileQualification.institution.id })
        }
        this.searching = true
        this.$http
          .get('search/qualification_components', { params })
          .then(({ data }) => {
            this.items = data
          })
          .finally(() => (this.searching = false))
      }
    }, 300),
  },

  methods: {
    setComponent(component) {
      if (typeof component === 'string') {
        // Set to unreferenced component
        this.component.qualificationComponentId = null
        this.component.description = component
        this.component.reference = ''
      } else if (component && typeof component === 'object') {
        // Set to referenced component
        this.component.qualificationComponentId = component.id
        this.component.description = component.description
        this.component.reference = component.reference
        // Set a scale if not has been set yet
        if (!this.component.gradeScale) this.component.gradeScale = component.gradeScale
      }
    },

    setGrade(grade) {
      this.component.gradeScale = grade.gradeScale
      this.component.gradeValue = grade.gradeValue
    },

    save: _.debounce(function() {
      this.saving = true
      this.$store
        .dispatch(`candidate/profileQualificationComponents/${this.value.id ? 'update' : 'create'}`, {
          profileQualification: { id: this.profileQualification.id },
          profileQualificationComponent: this.component,
        })
        .then(
          ({ data }) => {
            const description = data && data.description ? data.description : 'Component'
            this.$store.dispatch('snackbarSuccess', `${description} saved`)
            this.$emit('close')
          },
          error => {
            this.$store.dispatch('snackbarError', 'An error occured')
          }
        )
        .finally(() => (this.saving = false))
    }, 300),
  },
}
</script>
